import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {ConfigurationProfilesDialogsService} from "../../services/configuration-profiles-dialogs-service.service";
import {AgentConfigurationProfilesService} from "../../services/agent-configuration-profiles-service.service";
import {AgentsService} from "../../../agents/services/agents-service.service";
import {AgentPairingType} from "../../../agents/types/agentPairing.type";
import {AgentValidationType} from "../../../agents/types/agentValidation.type";
import {AgentConfigurationProfileModel} from "../../models/agent-configuration-profile.model";
import {AgentRequests} from "../../../agents/services/agent-requests.service";
import {AgentModel} from "../../../agents/angular/models/agent.model";
import {QuoteType} from "../../../fulfillment/types/quote.type";
import {SplitService} from "../../../commons/services/split-service.service";
import {AgentType} from "../../../agents/types/agent.type";
import {ConfigurationType} from "../../enums/configurationType.enum";

export class AutonomousAgentConfigurationProfileViewComponent implements IController {

  configurationProfile: any;
  agent: AgentModel;
  agentIds: any;
  defaultProfileId: any;
  selectedTab: string;

  public siteDistanceUnit: string;
  private pairingOptions: any = {None: "None", ProNumber: "ProNumber", Barcode: "Barcode"};
  private validationOptions: any = {None: "None", Barcode: "Barcode", ProNumber: "ProNumber", Click: "Click"}
  public agentValidationTypesMap: typeof AgentValidationType = AgentValidationType;
  private profileCopy: any;
  private isMobile: boolean;
  private isFooterDisplayed: boolean;
  private isCardExpanded: any;
  private agentsTotal: number;
  public quoteTypes: QuoteType[];
  public agentTypes: typeof AgentType = AgentType;
  public configurationTypes: typeof ConfigurationType = ConfigurationType;

  /* @ngInject */
  constructor(private agentConfigurationProfilesService: AgentConfigurationProfilesService, private $state,
              private configurationProfilesDialogsService: ConfigurationProfilesDialogsService, private splitService: SplitService,
              private $mdMedia, private agentsService: AgentsService, private agentRequests: AgentRequests) {
    this.siteDistanceUnit = splitService.getSiteDistanceSmallUnit();
  }

  $onInit() {

    this.quoteTypes = Object.values(QuoteType);
    this.isMobile = !this.$mdMedia('gt-md');
    this.isCardExpanded = {
      generalPreferences: false,
      geofencingPreferences: false,
      pairingPreferences: false,
      breakPreferences: false,
      routeCostPreferences: false,
      auctionPreferences: false,
      modulePreferences: false,
      itineraryPreferences: false,
      routeSelfAssignPreferences: false,
      serviceCreationPreferences: false,
      agentValidationPreferences: false
    }
    this.isFooterDisplayed = false;
    this.profileCopy = angular.copy(this.configurationProfile);

    if (!this.configurationProfile.notificationsPreferences) {
      this.configurationProfile.notificationsPreferences = {};
    }

    if (!this.configurationProfile.notificationsPreferences.stationaryNotificationPreferences) {
      this.configurationProfile.notificationsPreferences.stationaryNotificationPreferences = {};
    }

    // getting amount of assigned agents:
    this.agentsService.getAgentTotalsByConfigurationId(this.configurationProfile.id)
      .then((agentsTotal: any) => {
        this.agentsTotal = agentsTotal.total;
      })
  }

  $onChanges(changes) {
    if (changes.agent && !changes.agent.isFirstChange()) {
      this.agent = changes.agent.currentValue;
      this.configurationProfile = changes.agent.agentConfigurationProfile;
    }
  }

  onUpdateProfileInfo(profile, event) {
    this.configurationProfilesDialogsService.editAgentProfileInfo(profile, this.agentIds, event, undefined, [this.agentTypes.Robot])
      .then((payload) => {
        if (!_.isEqual(this.agentIds, payload.agentIds)) {
          const agentIdsRemoved = _.difference(this.agentIds, payload.agentIds);
          if (agentIdsRemoved.length) {
            this.onAssignAgentsToDefaultProfile(agentIdsRemoved);
          }
          if (payload.agentIds.length) {
            this.onAssignAgentsToProfile(profile.id, payload.agentIds, false);
          }
        }
        if (!_.isEqual(this.configurationProfile, payload.updatedProfile)) {
          this.onUpdateProfile(payload.updatedProfile);
        }
      })
  }

  onSelectChange(value, group, subGroup, property) {
    if (!this.profileCopy[group]) {
      this.profileCopy[group] = {};
    }

    if (!this.profileCopy[group][subGroup]) {
      this.profileCopy[group][subGroup] = {};
    }

    _.set(this.profileCopy[group][subGroup], property, value);
    this.onEditItem();
  }

  onChangePercentage(value, group, subGroup, property) {
    if (!this.profileCopy[group]) {
      this.profileCopy[group] = {};
    }

    if (!this.profileCopy[group][subGroup]) {
      this.profileCopy[group][subGroup] = {};
    }

    _.set(this.profileCopy[group][subGroup], property, value);
    this.onEditItem();
  }

  onToggleIgnoreValidations() {
    if (!this.profileCopy.appPreferences.validationsPreferences.ignoreValidations) {
      this.profileCopy.appPreferences.validationsPreferences.ignoreValidationOption = undefined;
    }

    this.onEditItem();
  }

  onEditItem() {
    if (!_.isEqual(this.configurationProfile, this.profileCopy)) {
      this.isFooterDisplayed = true;
    }
  }

  onSave(profile, form, event) {
    if (form) {
      form.$setSubmitted(true);
      if (form.$valid) {
        this.onUpdateProfile(profile);
      }
    }
  }

  onUpdateProfile(profile) {
    this.agentConfigurationProfilesService.updateOne(profile)
      .then((updatedProfile) => {
        this.configurationProfile = updatedProfile;
        this.$onInit();
      })
  }

  onAssignAgentsToProfile(profileId, agentIds, isDuplicated) {
    this.agentsService.assignConfigurationProfile(profileId, agentIds)
      .then((agents: any) => {
        this.agentsTotal = agents.length;
        const agentsRef = angular.copy(agents);
        this.agentIds = _.map(agentsRef, (agent: any) => {
          return agent.id;
        });
      }).then(() => {
      if (isDuplicated) {
        this.$state.go('site-administration.autonomous-agent-configuration-profile', {id: profileId});
      }
    })
  }

  onAssignAgentsToDefaultProfile(agentIds) {
    this.agentsService.assignConfigurationProfile(this.defaultProfileId, agentIds)
      .then((agents: AgentModel[]) => {
        this.profileCopy = angular.copy(this.configurationProfile);
        this.agentsTotal = agents.length;
      })
  }

  onCancelUpdateProfile() {
    this.profileCopy = angular.copy(this.configurationProfile);
    this.isFooterDisplayed = false;
  }

  onDelete(profileId) {
    this.agentConfigurationProfilesService.deleteOne(profileId)
      .then((removedProfile) => {
        this.$state.go('site-administration.configuration-profiles');
      })
  }

  onDuplicate(configurationProfile, event) {
    this.configurationProfilesDialogsService.createAgentProfileInfo(configurationProfile, event, true, [this.agentTypes.Robot])
      .then((payload) => {
        this.agentConfigurationProfilesService.createAgentConfigurationProfile(payload.newProfile)
          .then((newProfile: AgentConfigurationProfileModel) => {
            if (payload.agentIds.length !== 0) {
              this.onAssignAgentsToProfile(newProfile.id, payload.agentIds, false);
            }
            this.$state.go('site-administration.autonomous-agent-configuration-profile', {id: newProfile.id});
          })
      })
  }

  onPairingOptionChange(pairingOption) {
    if (pairingOption === AgentPairingType.Barcode) {
      this.profileCopy.appPreferences.pairingPreferences.quickValidation = false;
      this.validationOptions = [AgentValidationType.None, AgentValidationType.Barcode, AgentValidationType.Click];
      if (!_.includes(this.validationOptions, this.profileCopy.appPreferences.pairingPreferences.validationOption)) {
        this.profileCopy.appPreferences.pairingPreferences.validationOption = AgentValidationType.Barcode;
      }
    } else if (pairingOption === AgentPairingType.None) {
      this.validationOptions = angular.copy(Object.values(AgentValidationType));
      this.profileCopy.appPreferences.pairingPreferences.forcePairing = false;
    } else if (pairingOption === AgentPairingType.ProNumber) {
      this.validationOptions = [AgentValidationType.None, AgentValidationType.ProNumber, AgentValidationType.Click];
      if (!_.includes(this.validationOptions, this.profileCopy.appPreferences.pairingPreferences.validationOption)) {
        this.profileCopy.appPreferences.pairingPreferences.validationOption = AgentValidationType.ProNumber;
      }
    }
    this.onEditItem();
  }

  onChangeValidateBy(validationOption, propertyName) {
    this._setPairingOptions();

    if (validationOption === AgentValidationType.Barcode) {
      if (!_.includes(this.pairingOptions, this.profileCopy.appPreferences.pairingPreferences.pairingOption)) {
        this.profileCopy.appPreferences.pairingPreferences.pairingOption = AgentPairingType.Barcode;
      }
    } else if (validationOption === AgentValidationType.ProNumber) {
      this.profileCopy.appPreferences.pairingPreferences.pairingOption = AgentPairingType.ProNumber;
    } else if (validationOption === AgentValidationType.None) {
      this.profileCopy.appPreferences.pairingPreferences.quickValidation = false;
      if (!_.includes(this.pairingOptions, this.profileCopy.appPreferences.pairingPreferences.pairingOption)) {
        this.profileCopy.appPreferences.pairingPreferences.pairingOption = AgentPairingType.None;
      }
    } else if (validationOption === AgentValidationType.Click) {
      if (!_.includes(this.pairingOptions, this.profileCopy.appPreferences.pairingPreferences.pairingOption)) {
        this.profileCopy.appPreferences.pairingPreferences.pairingOption = AgentPairingType.None;
      }
    }
    this.onEditItem();
  }

  onForcePairingChange(forcePairing) {
    if (!!forcePairing) {
      this.pairingOptions = [AgentPairingType.ProNumber, AgentPairingType.Barcode];
      if (!_.includes(this.pairingOptions, this.profileCopy.appPreferences.pairingPreferences.pairingOption)) {
        this.profileCopy.appPreferences.pairingPreferences.pairingOption = this.pairingOptions[0];
      }
    }
    this.onEditItem();
  }

  // ******************************
  //        Private methods
  // ******************************

  private _setPairingOptions() {
    if (this.profileCopy.appPreferences.pairingPreferences.validationOption === AgentValidationType.Barcode) {
      this.pairingOptions = [AgentPairingType.None, AgentPairingType.Barcode];
    } else if (this.profileCopy.appPreferences.pairingPreferences.validationOption === AgentValidationType.ProNumber) {
      this.pairingOptions = [AgentPairingType.ProNumber];
    } else if (this.profileCopy.appPreferences.pairingPreferences.validationOption === AgentValidationType.None) {
      this.pairingOptions = [AgentPairingType.None, AgentPairingType.ProNumber, AgentPairingType.Barcode];
    } else if (this.profileCopy.appPreferences.pairingPreferences.validationOption === AgentValidationType.Click) {
      this.pairingOptions = [AgentPairingType.None, AgentPairingType.ProNumber, AgentPairingType.Barcode];
    } else {
      this.pairingOptions = angular.copy(Object.values(AgentPairingType));
    }
  }

}

angular
  .module('bringoz.admin.configuration-profiles')
  .component('autonomousAgentConfigurationProfileView', {
    bindings: {
      configurationProfile: '<',
      agent: '<?',
      agentIds: '<?',
      defaultProfileId: '<?',
      selectedTab: '<',
    },
    template: require('./autonomous-agent-configuration-profile-view.html').default,
    controller: AutonomousAgentConfigurationProfileViewComponent
  });
